import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=4decab7d&scoped=true"
import script from "./Merge.vue?vue&type=script&lang=js"
export * from "./Merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4decab7d",
  null
  
)

export default component.exports